import React from 'react';
import { Helmet } from 'react-helmet-async';

const Privacy: React.FC = () => (
  <main className="max-w-3xl mx-auto py-16 px-6 text-neutral-800">
    <Helmet>
      <title>Privacy Policy | rAIn Automation IDX</title>
      <meta
        name="description"
        content="Learn how rAIn Automation IDX collects, uses, and protects your data when using our website and services."
      />
      <meta name="robots" content="index, follow" />
      <link rel="canonical" href="https://idx.rainautomation.com/privacy" />
      <script type="application/ld+json">
        {`
        {
          "@context": "https://schema.org",
          "@type": "Product",
          "name": "rAIn IDX",
          "description": "Smarter IDX integration for real estate agents with SEO optimization, automated lead capture, and customizable listing displays.",
          "brand": {
            "@type": "Organization",
            "name": "rAIn Automation"
          }
        }
        `}
        </script>
    </Helmet>

    <h1 className="text-4xl font-extrabold tracking-tight mb-8 text-center">
      Privacy Policy
    </h1>
    <p className="text-lg leading-relaxed mb-10 text-center text-neutral-600">
      Your privacy is important to us. This policy explains how we collect, use, and protect your information when you use our site.
    </p>

    <div className="space-y-10 divide-y divide-neutral-200">
      <section className="pt-0">
        <h2 className="text-2xl font-semibold mb-3 text-neutral-900">1. Information We Collect</h2>
        <ul className="list-disc pl-6 text-base leading-relaxed">
          <li>Information you provide directly (e.g., forms, inquiries)</li>
          <li>Technical data (IP address, browser, device, usage patterns)</li>
          <li>Registration and saved property details</li>
        </ul>
      </section>

      <section className="pt-10">
        <h2 className="text-2xl font-semibold mb-3 text-neutral-900">2. How We Use Information</h2>
        <ul className="list-disc pl-6 text-base leading-relaxed">
          <li>To operate and improve our IDX platform</li>
          <li>To respond to inquiries or support requests</li>
          <li>To analyze traffic and improve functionality</li>
          <li>To comply with legal and MLS requirements</li>
        </ul>
      </section>

      <section className="pt-10">
        <h2 className="text-2xl font-semibold mb-3 text-neutral-900">3. Sharing of Information</h2>
        <ul className="list-disc pl-6 text-base leading-relaxed">
          <li><strong>We do not sell or rent your personal data.</strong></li>
          <li>We may share data with MLS providers or trusted vendors</li>
          <li>We may use aggregated, anonymous data for analysis</li>
        </ul>
      </section>

      <section className="pt-10">
        <h2 className="text-2xl font-semibold mb-3 text-neutral-900">4. Cookies & Analytics</h2>
        <p className="text-base leading-relaxed">
          We use cookies and analytics tools to improve your experience. You may disable cookies in your browser, though some features may be affected.
        </p>
      </section>

      <section className="pt-10">
        <h2 className="text-2xl font-semibold mb-3 text-neutral-900">5. Data Security</h2>
        <p className="text-base leading-relaxed">
          We implement safeguards to protect your data, but no internet transmission is entirely secure. Please exercise caution when sharing sensitive information.
        </p>
      </section>

      <section className="pt-10">
        <h2 className="text-2xl font-semibold mb-3 text-neutral-900">6. Children’s Privacy</h2>
        <p className="text-base leading-relaxed">
          Our platform is not directed to children under 13. We do not knowingly collect personal data from minors.
        </p>
      </section>

      <section className="pt-10">
        <h2 className="text-2xl font-semibold mb-3 text-neutral-900">7. Changes to This Policy</h2>
        <p className="text-base leading-relaxed">
          This Privacy Policy may be updated periodically. We encourage you to review it regularly for any changes.
        </p>
      </section>

      <section className="pt-10">
        <h2 className="text-2xl font-semibold mb-3 text-neutral-900">8. Contact Us</h2>
        <p className="text-base leading-relaxed">
          If you have questions, please contact us at{' '}
          <a href="mailto:support@rainautomation.com" className="text-blue-700 underline hover:text-blue-900 transition-colors">
            support@rainautomation.com
          </a>.
        </p>
      </section>
    </div>
  </main>
);

export default Privacy;